<template>
  <el-row :gutter="device == 'mobile' ? 12 : 40" class="panel-group">
    <el-col v-if="device == 'mobile'" :xs="24" :sm="24" :md="7" :lg="7" class="card-panel-col">
      <div class="card-panel" style="background-color: transparent; box-shadow: 0 0 0 0">
        <div class="avatar-upload-m">
          <div class="avatar-preview-m">
            <div class="avatar-edit-m">
              <input
                type="file"
                @change="previewFiles"
                id="imageUpload"
                accept=".png, .jpg, .jpeg"
              />

              <label for="imageUpload" class="el-icon-edit" style="padding: 9px"></label>
            </div>
            <div
              id="imagePreview"
              :style="{
                'background-image': `url(${avatar ? avatar : emptyUserImg})`,
              }"
            ></div>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :xs="6" :sm="12" :md="12" :lg="5" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping">
          <svg-icon icon-class="shopping" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">{{ isFree ? '免費試用天數' : '系統開通狀態' }}</div>
          <count-to
            v-show="isFree"
            :start-val="0"
            :end-val="diffDays"
            :duration="2000"
            style="color: red"
            class="card-panel-num"
          />
          <div style="color: #13ce66; font-size: 16px; padding: 2px 0" v-show="!isFree">使用中</div>
        </div>
      </div>
    </el-col>
    <el-col :xs="6" :sm="12" :md="12" :lg="5" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people">
          <svg-icon icon-class="peoples" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">每年出團總人數</div>
          <count-to
            :start-val="0"
            :end-val="perYearMemberCount"
            :duration="2000"
            class="card-panel-num"
          />
        </div>
      </div>
    </el-col>
    <el-col :xs="6" :sm="12" :md="12" :lg="5" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('cc')">
        <div class="card-panel-icon-wrapper icon-message">
          <svg-icon icon-class="message" class-name="card-panel-icon" />
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">客服詢問次數</div>
          <count-to
            :start-val="0"
            :end-val="recordRequests"
            :duration="2000"
            class="card-panel-num"
          />
        </div>
      </div>
    </el-col>
    <el-col :xs="6" :sm="12" :md="12" :lg="5" class="card-panel-col">
      <div class="card-panel" @click="handleSetLineChartData('analysis')">
        <div class="card-panel-icon-wrapper icon-chart">
          <svg-icon icon-class="chart" class-name="card-panel-icon" class="chart-icon" />
          <!-- <i style="font-size: 48px" class="el-icon-s-release"></i> -->
        </div>
        <div class="card-panel-description">
          <div class="card-panel-text">活動數據分析報告</div>
          <count-to
            :start-val="0"
            :end-val="travelQtyByOver"
            :duration="2000"
            class="card-panel-num"
          />
        </div>
      </div>
    </el-col>

    <div v-if="device != 'mobile'" class="avatar-upload">
      <div class="avatar-edit">
        <input type="file" @change="previewFiles" id="imageUpload" accept=".png, .jpg, .jpeg" />

        <label for="imageUpload" class="el-icon-edit" style="padding: 9px"></label>
      </div>
      <div class="avatar-preview">
        <div
          id="imagePreview"
          :style="{
            'background-image': `url(${avatar ? avatar : emptyUserImg})`,
          }"
        ></div>
      </div>
    </div>
    <travel-analysis-dialog :visible.sync="travelAnalysisDialogVisible" />
  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'
import { getAnAgencyAvatarByCode, saveAgencyAvatar } from '@/api/agency'
import { convertFileToBase64 } from '@/utils/funcs'
import { mapGetters } from 'vuex'
import TravelAnalysisDialog from '@/components/Dialog/TravelAnalysisDialog.vue'

export default {
  components: {
    CountTo,
    TravelAnalysisDialog,
  },
  props: {
    isFree: {
      type: Boolean,
      default: false,
    },
    diffDays: {
      type: Number,
      default: 0,
    },
    perYearMemberCount: {
      type: Number,
      default: 0,
    },
    chatCount: {
      type: Number,
      default: 0,
    },
    recordRequests: {
      type: Number,
      default: 0,
    },
    travelQtyByOver: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters(['device']),
  },
  data() {
    return {
      agencyCode: '',
      avatar: '',
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      formData: {},
      emptyUserImg: `${process.env.VUE_APP_S3_LINK}/base/temp_images/empty-user.png`,
      travelAnalysisDialogVisible: false,
    }
  },
  async created() {
    if (this.$store.getters.userInfo && this.$store.getters.userInfo.agencyCode) {
      this.agencyCode = this.$store.getters.userInfo.agencyCode
      await this.getAnAgencyAvatarByCode()
    }
  },
  methods: {
    async getAnAgencyAvatarByCode() {
      let resp = await getAnAgencyAvatarByCode({
        code: this.$store.getters.userInfo.agencyCode,
      })
      this.avatar = resp.data
      // console.log(this.avatar );
    },
    async previewFiles(event) {
      // console.log(event.target.files);
      let fileModel = {
        type: 4,
        files: [],
      }

      for (var i = 0; i < event.target.files.length; i++) {
        const f = event.target.files[i]

        await convertFileToBase64(f).then((resolve, reject) => {
          fileModel.files.push({
            fileName: f.name,
            base64: resolve,
          })
        })
      }
      if (fileModel && fileModel.files.length && confirm(`確定更換旅行社Logo?`)) {
        let f = fileModel[0]
        let payload = {
          agencyCode: this.agencyCode,
          fileInfo: [fileModel],
        }

        let resp = await saveAgencyAvatar(payload)

        await this.getAnAgencyAvatarByCode()
      }
    },
    async handleSetLineChartData(type) {
      switch (type) {
        case 'ms':
          this.$router.push('/chat/index')
          break
        case 'analysis':
          try {
            this.travelAnalysisDialogVisible = true
          } catch (error) {
            console.error(error)
          }
          break
        default:
          this.$router.push('/agency/agencyRecordRequest/index')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #000;
      }

      .icon-chart {
        background: #e6a100;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #000;
    }

    .icon-chart {
      color: #e6a100;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 12px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }

  .card-panel {
    height: auto !important;
  }

  .card-panel-icon {
    font-size: 32px !important;
  }

  .filter-form {
    .el-form-item {
      width: 100% !important;
    }
  }

  .dialogByTravelAnalysis {
    ::v-deep .el-dialog {
      width: 100vw !important;
      height: 100vh !important;
      margin: 0 !important;
      top: 0 !important;
    }
  }
}

.avatar-upload {
  right: 30px;
  top: 90px;
  z-index: 200;
  position: fixed;
  max-width: 205px;
  margin: 2px auto;

  .avatar-edit {
    position: absolute;
    right: 12px;
    z-index: 1;
    top: 10px;

    input {
      display: none;

      + label {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;

        border: 1px solid transparent;
        border-color: #fff4cb;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        font-weight: normal;
        transition: all 0.2s ease-in-out;

        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }

        &:after {
          // content: "\f040";
          // font-family: "FontAwesome";
          color: #757575;
          position: absolute;
          top: 10px;
          left: 0;
          right: 0;
          text-align: center;
          margin: auto;
        }
      }
    }
  }

  .avatar-preview {
    width: 120px;
    height: 120px;
    position: relative;
    border-radius: 100%;
    border: 6px solid #ffe483;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    > div {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}

.avatar-upload-m {
  // right: 48px;
  // top: 90px;
  // z-index: 200;
  // position: fixed;
  max-width: 125px;
  margin: 2px auto;

  .avatar-edit-m {
    position: absolute;
    left: 85px;
    z-index: 1;
    top: -5px;

    input {
      display: none;

      + label {
        display: inline-block;
        width: 34px;
        height: 34px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;

        border: 1px solid transparent;
        border-color: #fff4cb;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        font-weight: normal;
        transition: all 0.2s ease-in-out;

        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }

        &:after {
          // content: "\f040";
          // font-family: "FontAwesome";
          color: #757575;
          position: absolute;
          top: 10px;
          left: 0;
          right: 0;
          text-align: center;
          margin: auto;
        }
      }
    }
  }

  .avatar-preview-m {
    width: 100%;
    // height: 105px;
    aspect-ratio: 1;
    position: relative;
    border-radius: 100%;
    border: 6px solid #ffe483;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    > div {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}
</style>
